import { DialogType, MessageType } from "../types/types";
const SEND_MESSAGE = "dialogsPage/SEND-MESSAGE";


export type InitialStateType = typeof initialState

let initialState = {
  newMessageText: "",
  messages: [{ message: "( ͡° ͜ʖ ͡°)", id: 1 }] as Array<MessageType>,
  dialogs: [
    { id: 1, name: "sgt. Florida" },
    { id: 2, name: "cth" },
    { id: 3, name: "FV" },
    { id: 4, name: "Valentin Oblomov" },
    { id: 5, name: "ШУТУП" },
  ] as Array<DialogType>,
};

const dialogsReducer = (state = initialState, action: any): InitialStateType => {
  switch (action.type) {
    case SEND_MESSAGE:
      {
        let newMessage = {
          id: 2,
          message: action.newMessageText
        };

        return {
          ...state,
          messages: [...state.messages, newMessage],
          newMessageText: ""
        }
      }

    default:
      return state;
  }
};

type SendMessageActionType = {
  type: typeof SEND_MESSAGE,
  newMessageText: string
}

export const sendMessage = (newMessageText: string): SendMessageActionType => ({
  type: SEND_MESSAGE,
  newMessageText,
});

export default dialogsReducer;
